import React from "react";

import { Box, Flex, Span } from "@catchoftheday/cg-components";
import { formatPrice } from "@catchoftheday/utilities";

import productPriceSplit from "../../utilities/productPriceSplit.utilities";
import { Saving } from "../ProductCard/productCardTypes";

import { ProductPriceAside } from "./ProductPriceAside";
import { ProductPriceItemChildren } from "./ProductPriceItem";
import { ProductPriceMain } from "./ProductPriceMain";
import { ProductPriceParts } from "./ProductPriceParts";

type ProductPriceSellProps = {
  price: number;
  saving?: Saving | null;
  wasPrice?: number | null;
  onePassExclusive?: boolean;
  hasPromotion?: boolean;
  enabled: boolean;
  large?: boolean;
};

export const ProductPriceSell = ({
  price,
  saving,
  wasPrice,
  onePassExclusive,
  hasPromotion,
  enabled,
  large,
}: ProductPriceSellProps) => {
  const showCents = !!wasPrice && !!productPriceSplit(wasPrice, true).cents;

  const hasAside = !!wasPrice || !!saving;
  return (
    <Box
      className="sell-price"
      width="fit-content"
      fontWeight="base"
      data-testid="product-price"
    >
      <ProductPriceItemChildren>
        {wasPrice && (
          <ProductPriceAside showArrow large={large}>
            <Flex
              marginRight={hasPromotion ? "0" : "4px"}
              fontSize={large ? "2.5rem" : "1.75rem"}
            >
              <Span
                fontSize={
                  showCents ? "0.5em" : { sm: "0.625em", md: "0.656em" }
                }
                fontWeight="semibold"
                textDecoration="line-through"
                color={enabled ? "typography.text" : "typography.inactive"}
              >
                {formatPrice(wasPrice, false)}
              </Span>
            </Flex>
          </ProductPriceAside>
        )}

        <ProductPriceMain
          onePassExclusive={onePassExclusive}
          hasAside={hasAside}
          hasPromotion={hasPromotion}
          enabled={enabled}
          large={large}
        >
          <ProductPriceParts price={price} fontWeight="semibold" />
        </ProductPriceMain>

        {saving && (
          <ProductPriceAside large={large}>
            <Flex>
              <Span
                textTransform="uppercase"
                fontSize={large ? "0.9rem" : "0.728rem"}
                fontWeight="semibold"
                color={enabled ? "typography.text" : "typography.inactive"}
                lineHeight="1rem"
              >
                {saving.label}
                <br />
                {formatPrice(saving.savingAmount.amount, false)}
              </Span>
            </Flex>
          </ProductPriceAside>
        )}
      </ProductPriceItemChildren>
    </Box>
  );
};
